import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import {
  AgreementLegalContextSettings,
  AgreementConditionsSettings,
  AgreementJurisdictionLiabilityCard,
  useAgreementDetailsStep,
} from 'src/containers/Escrow/Agreement';

const AgreementDetails = () => {
  const {
    softwareEscrow: { id: escrowId, agreement },
  } = useSoftwareEscrow();

  const { onUpdateAgreement, isLegalContextOtherInvalid, isConditionsOtherInvalid } = useAgreementDetailsStep({
    escrowId,
    agreement,
    missingSelectionError: 'Select at least one legal context and one release event to continue.',
    missingOtherError: 'Fill in the required "Other" field to continue.',
  });

  return (
    <SoftwareOnboardingMain
      subtitle="Agreement information: Details"
      title="Tailor the agreement to your arrangement"
      description="Choose one or all that are applicable."
    >
      <div className="max-w-260 w-full mx-auto space-y-4">
        <AgreementLegalContextSettings
          onUpdate={onUpdateAgreement}
          onOtherChange={(legalContextOther) => onUpdateAgreement({ legalContextOther })}
          legalContext={agreement.legalContext}
          legalContextOther={agreement.legalContextOther ?? ''}
          isOtherInvalid={isLegalContextOtherInvalid}
        />
        <AgreementConditionsSettings
          title="Release events"
          description="Select from the standard terms, or define the specific conditions under which the beneficiary can request the release of the escrow materials. Choose one or all that are applicable."
          onUpdate={onUpdateAgreement}
          onOtherChange={(conditionsOther) => onUpdateAgreement({ conditionsOther })}
          conditions={agreement.conditions}
          conditionsOther={agreement?.conditionsOther ?? ''}
          isOtherInvalid={isConditionsOtherInvalid}
        />
        <AgreementJurisdictionLiabilityCard
          jurisdiction={agreement.jurisdiction ?? undefined}
          liability={agreement.liability ?? undefined}
          onJurisdictionUpdate={onUpdateAgreement}
          onLiabilityUpdate={onUpdateAgreement}
        />
      </div>
    </SoftwareOnboardingMain>
  );
};

export default AgreementDetails;
